import React from 'react'
import IconBase from './IconBase'

const Right = props => (
  <IconBase viewBox="0 0 24 41" {...props}>
    <path d="M22.6 22.5L5.3 39.7a2.84 2.84 0 0 1-4 0 2.84 2.84 0 0 1 0-4l15.3-15.2L1.4 5.3c-1.1-1.1-1.1-2.9 0-4s2.9-1.1 4 0l17.2 17.2c1.1 1.1 1.1 2.9 0 4z" />
  </IconBase>
)

export default Right
